import { UserOutlined } from "@ant-design/icons";
import {
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Row,
  Space,
  Typography,
} from "antd";
import GeneralPhoneNumber from "apps/Common/GeneralPhoneNumber";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { MazakaPassword } from "apps/Common/MazakaPassword";
import useMazakaForm from "hooks/useMazakaForm";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PaymentResult from "./SuccessPayment";

const ConfirmPayment = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const handleOnFinish = () => {
    setIsShowPaymentResult(true)
  };
  const { Text } = Typography;
  const navigate = useNavigate();
  const [isShowPaymentResult,setIsShowPaymentResult] = useState(false)
  return (
    <>
      <Col span={24} className="!mt-4">
      {
        isShowPaymentResult?<><PaymentResult/></>:
        <>
        
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="!px-4">
            <Col xs={24} className="!flex justify-center" >
                <LazyLoadImage wrapperWidth="200px" wrapperHeight="200px" src="https://cdn-icons-png.flaticon.com/512/10450/10450444.png" alt="" />
            </Col>
            <Col span={24}>
              <Row gutter={[0,20]}>
                <Col span={24}>
                  <Text className="!text-[#164194] !text-xl">
                    İlanı Öne Çıkartma Paketi
                  </Text>
                </Col>
                <Col span={24} className="!flex justify-between">
                  <Text className="!text-[#6E7583] ">
                    Keşfette öne çıkartma
                  </Text>
                  <Text className="!text-[#6E7583] !font-bold ">500TL</Text>
                </Col>
                <Col span={24} className="!flex justify-between">
                  <Text className="!text-[#6E7583] ">
                    Kalın yazı ve Renkli çerçeve
                  </Text>
                  <Text className="!text-[#6E7583] !font-bold">800TL</Text>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Divider className="!m-0" />
            </Col>
            <Col span={24}>
              <Row>
                <Col xs={24} lg={6}>
                  <div>
                    <Text className="!text[#6E7583] !font-bold !text-xl">
                      Toplam
                    </Text>
                  </div>
                  <div>
                    <Text className="!text[#164194] !text-base">10.000,00 TL</Text>
                  </div>
                </Col>
                <Col xs={24} lg={18} className="!flex items-center">
                  <MazakaButton
                    className="!p-4 !bg-[#FFC502] !text-black"
                    htmlType="submit"
                    block
                    processType={formActions.submitProcessType}
                  >
                    Onayla
                  </MazakaButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </MazakaForm>
        </>
      }
      </Col>
    </>
  );
};

export default ConfirmPayment;
